import { render, staticRenderFns } from "./BaseTableIncludableData.vue?vue&type=template&id=73190876&"
import script from "./BaseTableIncludableData.vue?vue&type=script&lang=js&"
export * from "./BaseTableIncludableData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports